import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Alert, Box, Button, Typography } from "@mui/material";
import { getInvitationInfo } from "apis/controllers/users";
import background from "assets/images/login-background.png";
import { jwtDecode } from "jwt-decode";
import { useState } from "react";
import { useParams } from "react-router-dom";

const Welcome = () => {
  const { token } = useParams();

  const [error, setError] = useState<{ status: string; message: string } | null>(null);
  const [loading, setLoading] = useState(false);
  const [hasRedirected, setHasRedirected] = useState(false);

  const checkToken = async () => {
    // 🛡️ Αν ήδη φορτώνει ή έχουμε ξεκινήσει redirect, αγνόησε τα επόμενα κλικ
    if (loading || hasRedirected) return;

    setLoading(true);
    setError(null);

    try {
      if (!token) {
        throw new Error("Missing token");
      }

      const decodedToken: any = jwtDecode(token);

      if (!decodedToken?.nameid) {
        throw new Error("Invalid token: missing nameid");
      }

      const res = await getInvitationInfo(decodedToken.nameid, token);
      const provider = res?.data?.provider;
      const baseUrl = import.meta.env.VITE_REACT_APP_BASE_URL;

      if (!baseUrl) {
        throw new Error("Missing base URL");
      }

      if (provider === "GSIS_PA") {
        const fullUrl = `${baseUrl}/auth/GoGsis_PAInvitation?id=${decodedToken.nameid}`;
        setHasRedirected(true);
        window.location.href = fullUrl;
        return;
      }

      if (provider === "GSIS") {
        const fullUrl = `${baseUrl}/auth/GoGsisInvitation?id=${decodedToken.nameid}`;
        setHasRedirected(true);
        window.location.href = fullUrl;
        return;
      }

      // Αν δεν είναι κανένας από τους δύο provider
      throw new Error("Άγνωστος πάροχος σύνδεσης.");
    } catch (e) {
      console.error(e);
      setError({
        status: "error",
        message: "Προέκυψε κάποιο σφάλμα. Παρακαλούμε προσπαθήστε ξανά!",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.8)), url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "70vh",
        width: "100%",
        marginTop: "-20px",
        alignContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          p: 4,
          maxWidth: 850,
          mx: "auto",
          bgcolor: "#fefefe",
          borderRadius: 2,
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      >
        <Typography variant="h4" fontWeight={700} sx={{ mb: 2 }}>
          Καλωσορίσατε στο ΛΑΕ!
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          Έχετε προσκληθεί στην Ηλεκτρονική Πλατφόρμα του ΛΑΕ.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          Τα βήματα που πρέπει να ακολουθήσετε για να εισέλθετε στην πλατφόρμα
          είναι:
        </Typography>

        <Typography variant="body1" sx={{ whiteSpace: "pre-line", mb: 3 }}>
          1) Επαλήθευση στοιχείων μέσω TaxisNet{"\n"}
          2) Επιβεβαίωση στοιχείων ΛΑΕ
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          endIcon={<ArrowForwardIcon />}
          sx={{ textTransform: "none", borderRadius: 2, mb: 3 }}
          onClick={checkToken}
          disabled={loading || hasRedirected}
        >
          {loading ? "Παρακαλώ περιμένετε..." : "Συνέχεια μέσω TaxisNet"}
        </Button>

        {error && <Alert severity="error">{error.message}</Alert>}
      </Box>
    </div>
  );
};

export default Welcome;
